// ============================================================
// lib/perfil/meu-perfil.ts
// ============================================================
// O proprio perfil lido pelo navegador (2026-09-25).
//
// A migration 064 tirou o anon de public.profiles (nome, WhatsApp, CPF). As
// telas de venda que preenchiam o checkout liam profiles direto pelo PostgREST
// publico, com a chave anon (lib/supabase/client.ts), e passaram a receber erro
// de permissao. Nada quebrava: o formulario so vinha vazio. Agora a leitura
// passa pelo servidor, com a sessao: GET /api/perfil.
//
// buscarMeuPerfil() devolve { data } como o .single() do supabase, para cada
// tela trocar so a consulta. Sem sessao, sem linha em profiles ou com falha:
// { data: null }, que as telas ja tratavam.
//
// Arquivo proprio e sem import de servidor (como mascaras.ts), para o client
// component importar sem puxar o banco junto: lib/perfil/index.ts importa lib/db.
// ============================================================

/** O que o navegador recebe do proprio perfil. Nada alem destes quatro campos. */
export interface MeuPerfil {
  full_name: string | null
  phone: string | null
  document: string | null
  avatar_url: string | null
}

function textoOuNull(v: unknown): string | null {
  return typeof v === 'string' ? v : null
}

/**
 * Recorta os quatro campos do perfil. Vale nos dois lados: a rota nao manda
 * is_admin, role nem outra coluna, e o navegador nao confia no formato recebido.
 */
export function somenteMeuPerfil(p: unknown): MeuPerfil | null {
  if (!p || typeof p !== 'object' || Array.isArray(p)) return null
  const o = p as Record<string, unknown>
  return {
    full_name: textoOuNull(o.full_name),
    phone: textoOuNull(o.phone),
    document: textoOuNull(o.document),
    avatar_url: textoOuNull(o.avatar_url),
  }
}

/** Le o proprio perfil pela sessao (cookie httpOnly). Nunca lanca. */
export async function buscarMeuPerfil(): Promise<{ data: MeuPerfil | null }> {
  try {
    const res = await fetch('/api/perfil', { credentials: 'include', cache: 'no-store' })
    if (!res.ok) return { data: null }
    const json = (await res.json()) as { perfil?: unknown } | null
    return { data: somenteMeuPerfil(json?.perfil) }
  } catch {
    return { data: null }
  }
}
